module.exports = __webpack_public_path__ + "9d6ca537ed2cdda12b0ca4379fdca94f.svg";